import type { FooterColumnProps } from './footer.types'

import Box from '../box'
import { useStyleConfig, vui } from '../core'
import { cs } from '../utils'
import { useFooterContext } from './context'
import FooterSection from './footerSection'

/** Organizes sections with links into a single column. Different width per breakpoint. */
const FooterColumn = vui<'div', FooterColumnProps>((props, ref) => {
  const { children, className, sections, flex, maxW, ...rest } = props
  const styles = useStyleConfig('Footer', useFooterContext())

  return (
    <Box
      className={cs('vui-footerColumn', className)}
      column
      {...styles.column}
      flex={flex ?? { xs: '0 0 50%', sm: '0 0 50%', md: '0 0 25%' }}
      minW={{ xs: 'auto', sm: '165px' }}
      maxW={maxW ?? { xs: 'calc(50% - 8px)', sm: 'auto' }}
      p={{ xs: 0, sm: 1, md: 1.25, lg: 1.5 }}
      ref={ref}
      spaceY={4}
      {...rest}
    >
      {children ?? sections?.map((section, index) => <FooterSection key={index} {...section} />)}
    </Box>
  )
})

FooterColumn.displayName = 'FooterColumn'
export default FooterColumn
